import CopyToClipboard from 'components/CopyToClipboard'
import styled from 'styled-components'
import { color } from 'utils/styledHelper'

export const InstructionsContentSection = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`

export const InstructionsSectionTitle = styled.h2`
  font-weight: 600;
  font-size: 1rem;
  line-height: 150%;
  font-feature-settings: 'ss01' on, 'zero' on;
  color: ${color('grey100')};
`

export const InstructionsSectionList = styled.ul`
  padding: 0;
  margin: 0;
  border: 1px solid ${color('dark200')};
  border-radius: 0.5rem;
`

export const InstructionsSectionListItem = styled.li`
  border-bottom: 1px solid ${color('dark200')};
  padding: 1rem;
  display: grid;
  grid-template:
    'label copy'
    'value copy';
  grid-template-columns: auto 56px;
  align-items: center;

  :first-child {
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }
  :last-child {
    border-bottom: 0;
  }
`

export const InstructionsSectionItemTitle = styled.span`
  grid-area: label;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 150%;
  font-feature-settings: 'zero' on;
  color: ${color('white')};
`

export const InstructionsSectionItemBody = styled.span`
  grid-area: value;
  font-weight: 600;
  font-size: 1rem;
  line-height: 150%;
  font-feature-settings: 'ss01' on, 'zero' on;
  color: ${color('dark200')};
  display: flex;

  > div {
    display: inline;
    margin-left: 4px;
  }
`

export const InstructionsCopy = styled(CopyToClipboard)`
  grid-area: copy;
  display: flex;
  justify-content: center;
`

export const InstructionsFooter = styled.div`
  padding: 1rem;
  margin: 1rem 0;
  border: 1px solid ${color('dark200')};
  border-radius: 0.5rem;
`

export const InstructionsFooterTitle = styled.h2`
  font-weight: 600;
  font-size: 1rem;
  line-height: 150%;
  font-feature-settings: 'ss01' on, 'zero' on;
  padding-bottom: 3px;
  color: ${color('white')};
  margin: 0;
`

export const InstructionsFooterBody = styled.p`
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 150%;
  font-feature-settings: 'zero' on;
  color: ${color('dark200')};
  margin: 0;
`
